<!--suppress JSUnusedGlobalSymbols, HtmlUnknownTag -->
<template>
  <div class="modal" data-backdrop="static" id="bsProposalSaveFormDialog" ref="bsProposalSaveFormDialog">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content viewDetails">
        <div ref="modalBodyBackdrop"
             style="position: absolute; top: 0; bottom: 0; left: 0; right: 0; background-color: rgba(0 ,0, 0, 0.05); z-index: 1050; display: none;"
             @click.prevent="onBackdropClick"></div>
        <form name="saveProposal"
              :action="pUrls['saveProposal']"
              method="post" class="ajax-support show-waiting"
              data-ajax-support-csv="#ajaxModuleForm,#proposalListHeader,#proposalListBody,#proposalViewBody">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span>
            </button>
            <h3 class="modal-title">{{ title }}</h3>
          </div>
          <div class="modal-body bs3-padding-top-reset bs3-padding-bottom-reset max-height fileupload-dropzone overflow-y-hidden"
               style="overflow-y: hidden;">
            <input type="hidden" name="dataForm.data.id" :value="data.id"/>

            <input type="hidden" name="src" :value="pSrc"/>
            <input type="hidden" name="srcId" :value="pSrcId"/>

            <div v-if="nbOfErrors > 0">
              <div class="bs3-padding text-center bs3-margin-left-minus15 bs3-margin-right-minus15 bg-danger">
                <span class="label label-danger">{{ nbOfErrors | error(pDictionary) }}</span>
              </div>
            </div>

            <div class="row scrollable-content scroll-y-xs noscroll-y-lg">
              <div class="col-md-12 col-lg-2 col-separator-right bs3-padding full-height-lg noscroll-y-xs scroll-y-lg">
                <!--
                  - ORGANIZATION SELECT
                  -->
                <organization-select
                    v-model="organizationIds"
                    :p-currencies="pCurrencies"
                    :p-language="pLanguage"
                    :p-dictionary="pDictionary"
                    :p-urls="pUrls"
                    :p-error-list="pErrorList"
                    :p-src="pSrc"
                    :p-src-id="pSrcId"
                    p-input-name="dataForm.organizationIds"
                    p-error-key="dataForm.data.organizationRefs"
                    p-select-container="#bsProposalSaveFormDialog"
                    :p-required="true"
                    :p-display-summary="true">
                </organization-select>
                <!--
                 - ORGANIZATION PROFILE LIST
                 -->
                <organization-profile-list
                    :p-currencies="pCurrencies"
                    :p-language="pLanguage"
                    :p-dictionary="pDictionary"
                    :p-urls="pUrls"
                    :p-error-list="pErrorList"
                    :p-src="pSrc"
                    :p-src-id="pSrcId"
                    :p-organization-ids="organizationIds">
                </organization-profile-list>
              </div>
              <div class="col-md-12 col-lg-10 col-separator bs3-padding full-height-lg noscroll-y-xs scroll-y-lg">
                <div class="row">
                  <div class="col-xs-5">
                    <!--
                     - NAME
                     --->
                    <div :class="['form-group', {'has-error': hasFieldErrors('dataForm.data.name')}]">
                      <div v-if="hasFieldErrors('dataForm.data.name')">
                        <span v-for="error in getFieldErrors('dataForm.data.name')" class="help-block" :key="error">{{ error }}</span>
                      </div>
                      <label v-else for="proposal_Name">
                        <span class="required">*</span> {{ pDictionary['dictionary.proposal.name'] }}
                      </label>
                      <input type="text"
                             id="proposal_Name"
                             :name="'dataForm.data.name'"
                             v-model="data.name"
                             class="form-control"
                             :placeholder="pDictionary['dictionary.proposal.name.placeholder']"/>
                    </div>
                  </div>
                  <div class="col-xs-3">
                    <!--
                     - RATECARD
                     --->
                    <media-rate-card-select
                        v-model="mediaRateCardId"
                        :p-currencies="pCurrencies"
                        :p-language="pLanguage"
                        :p-dictionary="pDictionary"
                        :p-error-list="pErrorList"
                        :p-src="pSrc"
                        :p-src-id="pSrcId"
                        p-input-name="dataForm.mediaRateCardId"
                        p-error-key="dataForm.data.mediaRateCardRef"
                        p-select-container="#bsProposalSaveFormDialog"
                        :p-required="false"
                        :p-option-ref="data.mediaRateCardRef">
                    </media-rate-card-select>
                  </div>
                  <div class="col-xs-2" v-if="supportMultipleCurrency">
                    <!--
                    - CURRENCY
                    --->
                    <div :class="['form-group', {'has-error': hasFieldErrors('dataForm.data.currencyRef.id')}]">
                      <div v-if="hasFieldErrors('dataForm.data.currencyRef.id')">
                        <span v-for="error in getFieldErrors('dataForm.data.currencyRef.id')" class="help-block" :key="error">{{ error }}</span>
                      </div>
                      <label v-else for="statusSelect">
                        <span class="required">*</span> {{ pDictionary['dictionary.currency'] }}
                      </label>
                      <select ref="currencySelect" name="dataForm.data.currencyRef.id" v-model="currencyId" class="form-control selectpicker" data-container="#bsProposalSaveFormDialog">
                        <option v-for="currency in pCurrencies"
                                :key="currency.id"
                                :value="currency.id">{{currency.name}}</option>
                      </select>
                    </div>
                  </div>
                  <input type="hidden" name="dataForm.data.currencyRef.id" v-model="currencyId" v-else/>
                  <div class="col-xs-2">
                    <!--
               - STATUS
               --->
                    <div :class="['form-group', {'has-error': hasFieldErrors('dataForm.data.status')}]">
                      <div v-if="hasFieldErrors('dataForm.data.status')">
                        <span v-for="error in getFieldErrors('dataForm.data.status')" class="help-block" :key="error">{{ error }}</span>
                      </div>
                      <label v-else for="statusSelect">
                        <span class="required">*</span> {{ pDictionary['dictionary.proposal.status'] }}
                      </label>
                      <select ref="statusSelect"
                              id="statusSelect"
                              name="dataForm.data.status"
                              class="form-control selectpicker"
                              data-container="#bsProposalSaveFormDialog">
                        <option value="DRAFT" :selected="data.status === 'DRAFT'">{{
                            pDictionary['dictionary.proposal.status.DRAFT']
                          }}
                        </option>
                        <option value="SENT" :selected="data.status === 'SENT'">{{ pDictionary['dictionary.proposal.status.SENT'] }}</option>
                        <option value="ACCEPTED" :selected="data.status === 'ACCEPTED'">{{
                            pDictionary['dictionary.proposal.status.ACCEPTED']
                          }}
                        </option>
                        <option value="PLANNED" :selected="data.status === 'PLANNED'">{{ pDictionary['dictionary.proposal.status.PLANNED'] }}
                        </option>
                        <option value="REJECTED" :selected="data.status === 'REJECTED'">{{
                            pDictionary['dictionary.proposal.status.REJECTED']
                          }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <!--
                 - PROPOSAL ITEMS
                 -->
                <fieldset class="bs3-margin-top30">
                  <legend>
                    <i class="fa-light fa-newspaper"></i> {{ pDictionary['dictionary.media.plural'] }}
                    <!-- Add -->
                    <media-format-advanced-picker
                        :p-dictionary="pDictionary"
                        :p-currencies="pCurrencies"
                        :p-currency-id="currencyId"
                        :p-media-rate-card-id="mediaRateCardId"
                        :pMediaExtraInfo1Enabled="mediaExtraInfo1Enabled"
                        :pMediaExtraInfo2Enabled="mediaExtraInfo2Enabled"
                        @media-format-select-open="onMediaFormatSelectOpen"
                        @media-format-select-close="onMediaFormatSelectClose"
                        @media-format-selected="onMediaFormatSelected">
                    </media-format-advanced-picker>
                      <div class="legend-checkbox right">
                          <label for="anonymizeMedia"
                                 class="sr-only">{{ pDictionary['dictionary.proposal.media.anonymize.tooltip'] }}</label>
                          <input id="anonymizeMedia"
                                 type="checkbox"
                                 name="dataForm.data.anonymizeMedia"
                                 value="true"
                                 v-model="data.anonymizeMedia"
                                 class="bs3-margin-right5"/>
                          <span class="bs3-margin-right3">{{ pDictionary['dictionary.proposal.media.anonymize'] }}</span>
                          <i class="fa-light fa-circle-question" aria-hidden="true"
                             data-toggle="tooltip" data-container="body" data-placement="top"
                             :title="pDictionary['dictionary.proposal.media.anonymize.tooltip']"></i>
                      </div>
                  </legend>
                  <div class="table-responsive">
                    <table class="table table-sm table-condensed-xs table-hover bs3-margin-bottom-reset bs3-vertical-center">
                      <thead>
                      <tr>
                        <th colspan="3">&nbsp;</th>
                        <th>{{ pDictionary['dictionary.media'] }}</th>
                        <th v-if="mediaExtraInfo1Enabled">{{ pDictionary['dictionary.media.extra.info1'] }}</th>
                        <th v-if="mediaExtraInfo2Enabled">{{ pDictionary['dictionary.media.extra.info2'] }}</th>
                        <th v-if="mediaExtraInfo3Enabled">{{ pDictionary['dictionary.media.extra.info3'] }}</th>
                        <th v-if="mediaExtraInfo4Enabled">{{ pDictionary['dictionary.media.extra.info4'] }}</th>
                        <th>{{ pDictionary['dictionary.market.plural'] }}</th>
                        <th>{{ pDictionary['dictionary.media.format'] }}</th>
                        <th>{{ pDictionary['dictionary.media.format.specification'] }}</th>
                        <th class="text-center width100Pixels text-nowrap">
                            <span class="bs3-margin-right5">{{ pDictionary['dictionary.proposal.item.date.start'] }}</span>
                            <proposal-column-date-action
                                    v-if="items.length > 0"
                                    p-button-id="start"
                                    @date-selected="onStartDateSelected">
                                <i class="fa-light fa-arrow-down-to-line"></i>
                            </proposal-column-date-action>
                        </th>
                        <th class="text-center width100Pixels text-nowrap">
                            <span class="bs3-margin-right5">{{ pDictionary['dictionary.proposal.item.date.end'] }}</span>
                            <proposal-column-date-action
                                    v-if="items.length > 0"
                                    p-button-id="end"
                                    @date-selected="onEndDateSelected">
                                <i class="fa-light fa-arrow-down-to-line"></i>
                            </proposal-column-date-action>
                        </th>
                        <th class="text-center width100Pixels text-nowrap">
                            <span class="bs3-margin-right5">{{ pDictionary['dictionary.proposal.item.date.delivery'] }}</span>
                            <proposal-column-date-action
                                    v-if="items.length > 0"
                                    p-button-id="delivery"
                                    @date-selected="onDeliveryDateSelected">
                                <i class="fa-light fa-arrow-down-to-line"></i>
                            </proposal-column-date-action>
                        </th>
                        <th class="text-right width100Pixels">{{ pDictionary['dictionary.proposal.item.unit.cost'] }}</th>
                        <th class="text-center">{{ pDictionary['dictionary.proposal.item.quantity'] }}</th>
                        <th class="text-right width100Pixels">{{ pDictionary['dictionary.proposal.item.cost'] }}</th>
                      </tr>
                      </thead>
                      <tbody v-if="items.length === 0">
                      <tr>
                        <td class="text-center" :colspan="nbOfCols"><span
                            class="emptyOrNull">{{ pDictionary['dictionary.general.none'] }}</span></td>
                      </tr>
                      </tbody>
                      <draggable v-model="items" element="tbody">
                      <proposal-item-row
                          v-for="(item, index) in items"
                          :key="itemKey(item, index)"
                          :p-dictionary="pDictionary"
                          :p-language="pLanguage"
                          :p-urls="pUrls"
                          :p-error-list="pErrorList"
                          :p-item.sync="item"
                          :p-index="index"
                          :p-media-extra-info1-enabled="mediaExtraInfo1Enabled"
                          :p-media-extra-info2-enabled="mediaExtraInfo2Enabled"
                          :p-media-extra-info3-enabled="mediaExtraInfo3Enabled"
                          :p-media-extra-info4-enabled="mediaExtraInfo4Enabled"
                          @proposal-item-copied="onCopyItem"
                          @proposal-item-removed="onRemoveItem"
                          @proposal-item-updated="onUpdateItem">
                      </proposal-item-row>
                      </draggable>
                      <tfoot>
                      <tr class="cost-separator">
                        <td :colspan="nbOfCols - 1" class="text-right">
                          <p class="form-control-static">{{ pDictionary['dictionary.proposal.total.cost'] }}:</p>
                        </td>
                        <td class="text-right">
                          <input type="text"
                                 id="dataForm_data_totalCostText"
                                 :name="'dataForm.data.totalCostText'"
                                 v-model="data.totalCostText"
                                 size="2" maxlength="10" readonly
                                 class="form-control input-sm text-right">
                        </td>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </fieldset>

                <!--
                - MEDIA NOTES
                -->
                <fieldset class="bs3-margin-top30">
                  <legend><i class="fa-light fa-bullseye-arrow" aria-hidden="true"></i>
                    {{ pDictionary['dictionary.proposal.media.profiles'] }}
                    <div class="legend-checkbox right">
                      <label for="includeMediaNotes"
                             class="sr-only">{{ pDictionary['dictionary.proposal.media.profiles.include.tooltip'] }}</label>
                      <input id="includeMediaNotes"
                             type="checkbox"
                             name="dataForm.data.includeMediaNotes"
                             value="true"
                             v-model="data.includeMediaNotes"
                             class="bs3-margin-right5"/>
                      <span class="bs3-margin-right3">{{ pDictionary['dictionary.proposal.media.profiles.include'] }}</span>
                      <i class="fa-light fa-circle-question" aria-hidden="true"
                         data-toggle="tooltip" data-container="body" data-placement="top"
                         :title="pDictionary['dictionary.proposal.mediaNotes.include.tooltip']"></i>
                    </div>
                  </legend>
                  <div v-if="mediaRefs.length === 0"><span class="emptyOrNull">{{ pDictionary['dictionary.general.none'] }}</span></div>
                  <div class="row" v-for="mediaRef in mediaRefs" :key="mediaRef.id">
                    <div class="col-xs-12">
                      <h4>{{ mediaRef.name }}</h4>
                      <p v-if="mediaRef.params.notes">{{ mediaRef.params.notes }}</p>
                      <p v-else><span class="emptyOrNull">{{ pDictionary['dictionary.general.none'] }}</span></p>
                    </div>
                  </div>
                </fieldset>

                <!--
                - NOTES
                -->
                <fieldset class="bs3-margin-top30 dropdown-menu-position-inline">
                  <legend><i class="fa-light fa-note-sticky" aria-hidden="true"></i>
                    {{ pDictionary['dictionary.proposal.notes'] }}
                  </legend>
                  <div class="row">
                    <div class="col-xs-12">
                      <div :class="['form-group', {'has-error': hasFieldErrors('dataForm.data.notes')}]">
                        <label for="notesRte" class="sr-only">{{ pDictionary['dictionary.proposal.notes'] }}</label>
                        <textarea ref="notesRte"
                                  id="notesRte"
                                  name="dataForm.data.notes"
                                  v-model="data.notes"
                                  class="form-control summernote" rows="10"></textarea>
                        <span v-for="error in getFieldErrors('dataForm.data.notes')" class="help-block" :key="error">{{ error }}</span>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="text-right">
              <button :disabled="buttonsDisabled" type="submit" class="btn btn-primary">
                <i class="fa-light fa-check"></i> <span>{{ pDictionary['dictionary.actions.save'] }}</span>
              </button>
              <a href="#"
                 :class="['btn btn-link', {'disabled': buttonsDisabled}]" data-dismiss="modal"
                 aria-label="Cancel">{{ pDictionary['dictionary.actions.cancel'] }}</a>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import stringhelpers from "@/helpers/string-helpers"
import eventhelpers from "@/helpers/event-helpers"
import OrganizationSelect from "@/components/organization/OrganizationSelect";
import OrganizationProfileList from "@/components/organization/OrganizationProfileList";
import MediaFormatAdvancedPicker from "@/components/media/MediaFormatAdvancedPicker";
import ProposalItemRow from "@/components/proposal/form/save/ProposalItemRow";
import MediaRateCardSelect from "@/components/media/ratecard/MediaRateCardSelect";
import ProposalColumnDateAction from "@/components/proposal/form/save/ProposalColumnDateAction.vue";

export default {
  name: "ProposalSaveForm",
  components: {ProposalColumnDateAction, ProposalItemRow, MediaFormatAdvancedPicker, OrganizationProfileList, OrganizationSelect, MediaRateCardSelect},
  props: {
    pCurrencies: Array,
    pLanguage: String,
    pDictionary: Object,
    pUrls: Object,
    pErrorList: {
      type: Object,
      default: function () {
        return {}
      }
    },
    pSrc: String,
    pSrcId: String,
    pDataForm: Object
  },
  data: function () {
    return {
      data: this.pDataForm.data,
      organizationIds: this.pDataForm.organizationIds,
      mediaRateCardId: this.pDataForm.mediaRateCardId,
      currencyId: this.pDataForm.currencyId,
      items: this.pDataForm.data.items,
      mediaRefs: this.pDataForm.data.mediaRefs,
      buttonsDisabled: false,
      errorList: []
    }
  },
  methods: {
    itemKey: function (item, index) {
      return item.id > 0 ? item.id : item.mediaRef.id + Date.now() + index;
    },
    onBackdropClick: function () {

    },
    onMediaFormatSelectOpen: function () {
      $(this.$refs.modalBodyBackdrop).show();
      this.buttonsDisabled = true;
    },
    onMediaFormatSelectClose: function () {
      $(this.$refs.modalBodyBackdrop).hide();
      this.buttonsDisabled = false;
    },
    onMediaFormatSelected: function (mediaFormatIds) {
      this.addItem(mediaFormatIds);
    },
    onCopyItem: function (index) {
      this.copyItem(index);
    },
    onRemoveItem: function (index) {
      this.removeItem(index);
    },
    onUpdateItem: function (item, initiatedByField) {
      this.refreshItem(item, initiatedByField, this.mediaRateCardId)
    },
     onStartDateSelected: function(startDateText) {
        $.each(this.items, function (index, item) {
           item.startDateText = startDateText;
        });
     },
     onEndDateSelected: function(endDateText) {
        $.each(this.items, function (index, item) {
           item.endDateText = endDateText;
        });
     },
     onDeliveryDateSelected: function(deliveryDateText) {
        $.each(this.items, function (index, item) {
           item.deliveryDateText = deliveryDateText;
        });
     },
    addItem: function (mediaFormatIds) {
      let _component = this;

      const data = {
        mediaFormatIds: mediaFormatIds,
        mediaRateCardId: _component.mediaRateCardId
      }

      $.ajax({
               type: "GET",
               url: "/mediaplan/app/endpoints/json-api/proposals/items/new",
               data: $.param(data, true),
               headers: {
                 'Accept': 'application/json',
                 'Content-Type': 'application/json'
               }
             }).done(function (data) {
        $.each(data, function (index, value) {
          _component.items.push(value);
          _component.errorList.push({});
          _component.updateTotalCost();
        });
      });
    },
    copyItem: function (index) {
      const _component = this;
      let item = _component.items[index];
      let newItem = JSON.parse(JSON.stringify(item));
      newItem.id = null;
      _component.items.push(newItem);
      _component.updateTotalCost();
    },
    removeItem: function (index) {
      const _component = this;
      _component.items.splice(index, 1);
      _component.updateTotalCost();
    },
    refreshItems: function (mediaRateCardId) {
      const _component = this;
      $.each(_component.items, function (index, item) {
        _component.refreshItem(item, "START_DATE", mediaRateCardId)
      });
    },
    refreshItem: function (item, initiatedByField, mediaRateCardId) {
      const _component = this;
      const index = this.items.indexOf(item);

      console.log("Refresh item at index", item, index);

      const data = {
        'dataInput': {
          'initiatedByField': initiatedByField,
          'mediaRateCardId': mediaRateCardId
        },
        'data': item
      }

      return $.ajax({
                      type: "POST",
                      url: "/mediaplan/app/endpoints/json-api/proposals/items/refresh",
                      data: JSON.stringify(data),
                      headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                      }
                    }).done(function (updatedItem) {
        _component.items.splice(index, 1, updatedItem);
        _component.updateTotalCost();
      });
    },
    updateTotalCost: function () {
      this.$nextTick(function () {
        $(this.$refs.bsProposalSaveFormDialog)
            .find('.proposalItemCost').sum({
                                             srcSumSelector: '.proposalItemCostText',
                                             dstTotalId: '#dataForm_data_totalCostText'
                                           });
      });
    },
    refreshRateCard: function (newOrganizationIds) {
      const _component = this;
      if(newOrganizationIds.length)
      {
        const data = {
          organizationIds: newOrganizationIds
        }
        return $.ajax({
                        type: "POST",
                        url: "/mediaplan/app/endpoints/json-api/ref/medias/rates/cards",
                        data: JSON.stringify(data),
                        headers: {
                          'Accept': 'application/json',
                          'Content-Type': 'application/json'
                        }
                      }).done(function (mediaRateCardRefs) {
          if(mediaRateCardRefs)
          {
            _component.mediaRateCardId = mediaRateCardRefs[0].id;
          }
        });
      }
      else
      {
        _component.mediaRateCardId = null;
      }
    },
    refreshMediaRefs: function () {
      const _component = this;
      const data = {
        mediaIds: _component.mediaIds
      }
      return $.ajax({
                      type: "POST",
                      url: "/mediaplan/app/endpoints/json-api/ref/medias",
                      data: JSON.stringify(data),
                      headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                      }
                    }).done(function (mediaRefs) {
        _component.mediaRefs = mediaRefs;
      });
    },
    isIdValid: function () {
      return this.data.id !== undefined
             && this.data.id > 0;
    },
    hasFieldErrors: function (name) {
      if(name in this.pErrorList)
      {
        return !$.isEmptyObject(this.pErrorList[name]);
      }
    },
    getFieldErrors: function (name) {
      if(name in this.pErrorList)
      {
        return this.pErrorList[name];
      }
      return [];
    }
  },
  computed: {
    title: function () {
      return this.isIdValid()
             ? this.pDictionary['dictionary.proposal.udate.title']
             : this.pDictionary['dictionary.proposal.create.title'];
    },
    nbOfErrors: function () {
      return Object.keys(this.pErrorList).length;
    },
    nbOfCols: function () {
      let nbOfCols = 13;
      if(this.mediaExtraInfo1Enabled)
      {
        nbOfCols++;
      }
      if(this.mediaExtraInfo2Enabled)
      {
        nbOfCols++;
      }
      if(this.mediaExtraInfo3Enabled)
      {
        nbOfCols++;
      }
      if(this.mediaExtraInfo4Enabled)
      {
        nbOfCols++;
      }
      return nbOfCols;
    },
    mediaIds: function () {
      const mediaIds = this.items.map(function (item) {
        return item.mediaRef.id;
      });
      return [...new Set(mediaIds)];
    },
    mediaExtraInfo1Enabled: function () {
      return this.pDictionary['dictionary.media.extra.info1'] !== 'notused'
    },
    mediaExtraInfo2Enabled: function () {
      return this.pDictionary['dictionary.media.extra.info2'] !== 'notused'
    },
    mediaExtraInfo3Enabled: function () {
      return this.pDictionary['dictionary.media.extra.info3'] !== 'notused'
    },
    mediaExtraInfo4Enabled: function () {
      return this.pDictionary['dictionary.media.extra.info4'] !== 'notused'
    },
    supportMultipleCurrency: function() {
      return this.pCurrencies.length > 1;
    },
  },
  watch: {
    organizationIds: function (newOrganizationIds) {
      const _component = this;
      _component.refreshRateCard(newOrganizationIds);
    },
    mediaIds: function () {
      const _component = this;
      _component.refreshMediaRefs();
    },
    mediaRateCardId: function (newMediaRateCardId) {
      const _component = this;
      _component.refreshItems(newMediaRateCardId)
    }
  },
  filters: {
    // TODO: Use mixin...
    safeReference: function (reference, dictionary, index) {
      if(!reference)
      {
        return dictionary['dictionary.proposal'] + index;
      }
      return reference;
    },
    i18nparams: function (text, index, param) {
      if(!text)
      {
        return text;
      }
      else
      {
        return stringhelpers.replaceAll(text, '__' + index + '__', param);
      }
    },
    money: function (value, currencies, currencyId) {
      if(value) {
        let currency = currencies.find(c => c.id === currencyId);
        if(currency) {
          if(currency.symbolPosition === 'BEFORE') {
            return currency.symbol + " " + value;
          }
          return value + " " + currency.symbol;
        }
      }
      return '-';
    },
    percent: function (value, dictionary) {
      if(!value)
      {
        return '-';
      }
      else
      {
        let percentFormat = dictionary['dictionary.format.percent.digit.4'];
        return stringhelpers.replaceAll(percentFormat, '__0__', value);
      }
    },
    error: function (value, dictionary) {
      if(!value)
      {
        return '-';
      }
      else
      {
        let errorFormat = dictionary['dictionary.general.errors'];
        return stringhelpers.replaceAll(errorFormat, '__0__', value);
      }
    }
  },
  mounted: function () {
    let _component = this;

    let $bsProposalSaveFormDialog = $(this.$refs.bsProposalSaveFormDialog);
    $bsProposalSaveFormDialog.on('shown.bs.modal', function () {
      // Create the tooltips.
      $bsProposalSaveFormDialog.find('[data-toggle="tooltip"]').tooltip();

      // Status select.
      let $statusSelect = $(_component.$refs.statusSelect);
      $statusSelect.selectpicker();
      $statusSelect.on('changed.bs.select', function (e, clickedIndex) {
        let $bsSelect = $(e.target);
        let $clickedOption = $bsSelect.find('option').eq(clickedIndex);
        if($clickedOption.val() <= 0)
        {
          $.each($bsSelect.find(":selected").not($clickedOption), function (index, option) {
            let $option = $(option);
            $option.prop('selected', false);
          });
        }
        else
        {
          $.each($bsSelect.find(":selected").not($clickedOption), function (index, option) {
            let $option = $(option);
            if($option.val() <= 0)
            {
              $option.prop('selected', false);
            }
          });
        }
        $bsSelect.selectpicker('refresh');
      });

      // Init currency select
      let $currencySelect = $(_component.$refs.currencySelect);
      $currencySelect.selectpicker();

      // Create Notes RTE.
      let $notesRte = $(_component.$refs.notesRte);
      $notesRte.summernote({
                             height: 300,
                             shortcuts: false,
                             disableDragAndDrop: true,
                             dialogsInBody: true,
                             toolbar: [
                               ['style', ['bold', 'italic', 'underline']],
                               ['font', ['strikethrough', 'superscript', 'subscript', 'clear']],
                               ['fontsize', ['fontsize']],
                               ['color', ['color']],
                               ['para', ['ul', 'ol', 'paragraph']]
                             ],
                             lang: _component.pLanguage === 'fr' ? 'fr-FR' : 'en-US'
                           });
      $notesRte.on('summernote.change', function () {
        eventhelpers.triggerNativeEvent($notesRte.get(0), 'input');
      });

      // Adapt layout
       $().adaptLayout();
    });

    $bsProposalSaveFormDialog.on('hidden.bs.modal', function () {
      // Destroy the tooltips.
      $bsProposalSaveFormDialog.find('[data-toggle="tooltip"]').tooltip('destroy');

      // Destroy Notes RTE.
      let $notesRte = $(_component.$refs.notesRte);
      $notesRte.summernote('destroy');
    });

    $(_component.$refs.bsProposalSaveFormDialog).modal();
  },
  updated: function(){
    let _component = this;
    // refresh currency select.
    let $currencySelect = $(_component.$refs.currencySelect);
    $currencySelect.selectpicker('refresh');
  },
  destroyed: function () {
    let _component = this;

    // destroy currency select.
    let $currencySelect = $(_component.$refs.currencySelect);
    $currencySelect.selectpicker('destroy');
  }
}
</script>

<style scoped>

</style>